import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  Divider,
  makeStyles,
  Typography
} from '@material-ui/core'
import { getIrpIncidence } from '../../api/irpIncidences.service'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import ResourceList from '../../components/Resources/ResourceList'
import AcceptIrpIncidence from './AcceptIrpIncidence'
import { formatDate } from '../../common/utils'
import { DialogTitle } from '../../components/DialogTitle'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  }
}))

const IrpIncidenceDetail = (props) => {
  const classes = useStyles()

  const id = props.id
  const handleClose = props.onClose

  const [loading, setLoading] = useState(false)
  const [stateForm, setStateForm] = useState({})
  const [isModalAcceptOpen, setIsModalAcceptOpen] = useState(false)

  const getData = useCallback(() => {
    setLoading(true)
    getIrpIncidence(id)
      .then((result) => {
        setStateForm(result.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [id])

  useEffect(() => {
    if (id !== undefined && id !== null) {
      getData()
    }
  }, [id, getData])

  const textEmpty = (text) => {
    if (text === undefined || text === null || text === '') {
      return '--'
    }
    if (typeof text == 'boolean') {
      return text ? 'Sí' : 'No'
    }
    return text
  }

  const Title = (_) => <h2>Incidencia IRP: {id}</h2>

  return (
    <div>
      <Grid container direction="column">
        <DialogTitle title={<Title />} />
        <Grid item>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={6}>
              <Typography color="primary" variant="body1">
                Fecha de la incidencia
              </Typography>
              <Typography variant="body1">
                {textEmpty(formatDate(stateForm.creationDate))}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography color="primary" variant="body1">
                Estado
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.state)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="primary" variant="body1">
                Descripción
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.description)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="primary" variant="body1">
                Comentario
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.comment)}</Typography>
            </Grid>
            <Grid item xs={12} className="pb-0">
              <Typography color="primary" variant="body1">
                Adjuntos
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <ResourceList resources={stateForm.attachments} />
            </Grid>
          </Grid>
          {handleClose !== undefined && (
            <SaveOrCancelButtons
              onSave={stateForm.isAccepted === false ? () => setIsModalAcceptOpen(true) : undefined}
              saveLabel="Aceptar Incidencia"
              onCancel={handleClose}
              cancelLabel="Cerrar"
              loading={loading}
            />
          )}

          <AcceptIrpIncidence
            open={isModalAcceptOpen}
            id={id}
            onCancel={() => setIsModalAcceptOpen(false)}
            onSave={
              handleClose
                ? handleClose
                : () => {
                    return
                  }
            }
          />
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default IrpIncidenceDetail
